var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-modal",
      class: [_vm.getActiveClass, _vm.getDialogClass],
      attrs: { id: _vm.dialogId },
    },
    [
      _c("div", { staticClass: "c-modal__inner" }, [
        _c("h6", { staticClass: "u-fs-18" }, [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _vm.cancelCallback
          ? _c(
              "div",
              {
                staticClass: "c-modal__close",
                on: { click: _vm.cancelCallback },
              },
              [
                _c("i", {
                  staticClass: "fal fa-times u-font-150 u-cursor-pointer",
                }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "c-modal__body" }, [
          _c("div", [
            _vm.text
              ? _c("div", [_c("span", [_vm._v(_vm._s(_vm.text))])])
              : _vm._e(),
            _vm._v(" "),
            _vm.html
              ? _c("div", [
                  _c("span", { domProps: { innerHTML: _vm._s(_vm.html) } }),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "c-modal__footer" }, [
          _c(
            "div",
            { staticClass: "u-flex-buttons u-jc-center" },
            [
              _vm.hasCancelButton
                ? _c(
                    "button",
                    {
                      staticClass:
                        "o-btn o-btn--outline o-btn--outline-primary o-btn--sm o-btn--rounded-sm",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.cancelCallback.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.cancelButtonText) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasConfirmButton
                ? _c(
                    "button",
                    {
                      staticClass:
                        "o-btn o-btn--sm o-btn--primary o-btn--rounded-sm",
                      class: _vm.getDialogClass,
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.confirmCallback.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.confirmButtonText) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.buttons, function (button, index) {
                return _c(
                  "button",
                  {
                    key: _vm.alertId + "-button-" + index,
                    staticClass:
                      "o-btn o-btn--sm o-btn--primary o-btn--rounded-sm",
                    class: _vm.getDialogClass,
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return button.callback.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n          " + _vm._s(button.text) + "\n        ")]
                )
              }),
            ],
            2
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }